import { DeviceWithConfig } from '@/types/common';

export const isDeviceConfigured = (device: DeviceWithConfig): boolean => {
  const orderTypes = device.config?.orderTypeIds;
  const printerProfiles = device.config?.printerProfileIds;

  return (
    Array.isArray(orderTypes) &&
    orderTypes.length > 0 &&
    Array.isArray(printerProfiles) &&
    printerProfiles.length > 0
  );
};
